<template>
  <f-box class="stat-simple p-7 has-row-2 has-no-col-gap has-no-row-gap" grid>
    <p class="is-col-12 color-gray">
      <b>
        <small>
          {{ title }}
        </small>
      </b>
    </p>

    <div class="is-col-12 m-0">
      <h6 class="color-blue-dark">
        <slot>
          {{ displayAmount(data) + ' ' + symbol }}
        </slot>
      </h6>
    </div>
  </f-box>
</template>

<script>
  import { computed } from 'vue'
  import useStatistics from '@composables/statistics/use-statistics.js'
  import useNumbers from '@composables/use-numbers'

  export default {
    props: {
      label: {
        type: [String, null],
        default: null,
      },

      data: {
        type: [Number, null],
        default: null,
      },

      symbol: {
        type: String,
        default: '',
      },

      year: {
        type: [Number, null],
        default: null,
      },

      month: {
        type: [Number, null],
        default: null,
      },

      from: {
        type: [Date, null],
        default: null,
      },
      
      to: {
        type: [Date, null],
        default: null,
      },
    },

    setup (props) {
      const { displayAmount, isNumber } = useNumbers()
      const {
        period,
        year: currentYear
      } = useStatistics(props)

      const title = computed(() => 
        props.label !== null ? props.label : period.value.formatted
      )

      return {
        displayAmount,
        title,
      }
    }
  }
</script>

<style lang="scss">
  .stat-simple {
    position: relative;

    h6 {
      margin: 0.5rem 0;
    }
  }
</style>
